/**
 * Avora Privacy Policy — Accordion, ToC scroll, expand/collapse
 */
(function () {
  'use strict';

  var sections = document.querySelectorAll('.avora-policy__section');
  var toggleBtn = document.querySelector('.avora-policy__toggle-all');
  var tocLinks = document.querySelectorAll('.avora-policy__toc-list a');

  /* ── Accordion toggle ── */
  sections.forEach(function (section) {
    var header = section.querySelector('.avora-policy__section-header');
    if (!header) return;

    header.addEventListener('click', function () {
      toggleSection(section);
    });
  });

  function toggleSection(section, forceOpen) {
    var content = section.querySelector('.avora-policy__section-content');
    var header = section.querySelector('.avora-policy__section-header');
    var isOpen = section.classList.contains('is-open');

    if (forceOpen === true && isOpen) return;
    if (forceOpen === false && !isOpen) return;

    if (isOpen) {
      section.classList.remove('is-open');
      header.setAttribute('aria-expanded', 'false');
      content.style.maxHeight = '0';
    } else {
      section.classList.add('is-open');
      header.setAttribute('aria-expanded', 'true');
      content.style.maxHeight = content.scrollHeight + 'px';
    }
  }

  /* ── Smooth scroll from ToC links ── */
  tocLinks.forEach(function (link) {
    link.addEventListener('click', function (e) {
      e.preventDefault();
      var targetId = link.getAttribute('href').substring(1);
      var target = document.getElementById(targetId);
      if (!target) return;

      // Open the section if collapsed
      if (!target.classList.contains('is-open')) {
        toggleSection(target, true);
      }

      // Smooth scroll with offset for sticky header
      setTimeout(function () {
        var offset = 100;
        var top = target.getBoundingClientRect().top + window.pageYOffset - offset;
        window.scrollTo({ top: top, behavior: 'smooth' });
      }, 50);
    });
  });

  /* ── Expand All / Collapse All ── */
  if (toggleBtn) {
    toggleBtn.addEventListener('click', function (e) {
      e.preventDefault();
      var allOpen = Array.from(sections).every(function (s) {
        return s.classList.contains('is-open');
      });

      sections.forEach(function (section) {
        toggleSection(section, !allOpen);
      });

      toggleBtn.textContent = allOpen ? 'Expand All' : 'Collapse All';
    });
  }

  /* ── Initialize first section as open ── */
  var firstSection = sections[0];
  if (firstSection) {
    var firstContent = firstSection.querySelector('.avora-policy__section-content');
    if (firstContent) {
      firstContent.style.maxHeight = firstContent.scrollHeight + 'px';
    }
  }

  /* ── Scroll reveal animation ── */
  var reveals = document.querySelectorAll('.avora-policy__reveal');

  if ('IntersectionObserver' in window) {
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -40px 0px' });

    reveals.forEach(function (el) {
      observer.observe(el);
    });
  } else {
    // Fallback: show everything
    reveals.forEach(function (el) {
      el.classList.add('is-visible');
    });
  }

  /* ── Open section from URL hash (e.g. #tos-section-6) ── */
  if (window.location.hash) {
    var hashTarget = document.getElementById(window.location.hash.substring(1));
    if (hashTarget && hashTarget.classList.contains('avora-policy__section')) {
      // Make it visible immediately
      hashTarget.classList.add('is-visible');
      // Open the accordion
      toggleSection(hashTarget, true);
      // Scroll to it after a short delay for layout
      setTimeout(function () {
        var offset = 100;
        var top = hashTarget.getBoundingClientRect().top + window.pageYOffset - offset;
        window.scrollTo({ top: top, behavior: 'smooth' });
      }, 300);
    }
  }
})();
